export default __webpack_public_path__ + "static/media/globe-desktop.0ed5d71d.svg";